import { useAtomValue } from "jotai";
import type { V2Role, V2User } from "@/v2/shared/model";
import { v2CurrentUserAtom } from "@/v2/auth/store";

export function useCurrentUser(): V2User {
  return useAtomValue(v2CurrentUserAtom);
}

export function useCurrentRole(): V2Role {
  return useAtomValue(v2CurrentUserAtom).role;
}

export function useIsManager(): boolean {
  return useAtomValue(v2CurrentUserAtom).role === "manager";
}
